export default {
  locations: {
    loading: false,
    error: null,
    data: [],
  },
};
